// Shared between the character page (client/SSR) and the sitemap source (server)
// so the "is this profile complete enough to index" rule lives in one place.

/** Dependency-free HTML-to-text for measuring bio length on either runtime. */
export function stripHtmlText(html: string | null | undefined): string {
  if (!html) return ''
  return html
    .replace(/<[^>]*>/g, ' ')
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/\s+/g, ' ')
    .trim()
}

export interface ProfileCompletenessInput {
  hasAvatar: boolean
  /** Raw bio (HTML or plain text); length is measured on stripped text. */
  bio: string | null | undefined
  linkCount: number
}

/**
 * A profile is index-worthy only when it has real content: an avatar AND
 * either a meaningful bio (>= 40 chars) or at least 2 links. Thin/empty
 * profiles get noindex,follow and are kept out of the sitemap.
 */
export function isProfileComplete(input: ProfileCompletenessInput): boolean {
  if (!input.hasAvatar) return false
  const bioLength = stripHtmlText(input.bio).length
  return bioLength >= 40 || input.linkCount >= 2
}
